import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const PincodeService = {
  get: async (offset, limit, searchQuery, state_id, district_id, taluka_id) => {
    try {
      const response = await axios.get(
        ApiConstants.pincode.baseUrl +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}&state_id=${
            state_id ?? ""
          }&district_id=${district_id ?? ""}&taluka_id=${taluka_id ?? ""}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAll: async (taluka_id) => {
    try {
      const response = await axios.get(
        ApiConstants.pincode.getAll + `?taluka_id=${taluka_id ?? ""}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.pincode.delete,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  changeStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.pincode.changeStatus,
        {
          id: id,
          isActive: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  create: async (name, taluka_id) => {
    try {
      const response = await axios.post(
        ApiConstants.pincode.baseUrl,
        {
          name: name.trim(),
          taluka_id: taluka_id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  update: async (id, name) => {
    try {
      const response = await axios.put(
        ApiConstants.pincode.baseUrl,
        {
          name: name.trim(),
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default PincodeService;
